import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {
  DialogHead as UIDialogHead,
  DialogTitle,
  IconButton,
} from '@travel-frontend/ui-components';

export const DialogHead = styled(UIDialogHead)(
  ({theme}) => css`
    background: ${theme.colors.backgroundTertiary};
    ${DialogTitle} {
      ${theme.typography.headlineSmall};
      margin: 0 auto;
    }
    ${IconButton} {
      margin-left: 0 !important;
    }
  `
);
